import { render, staticRenderFns } from "./CalendarDefault.vue?vue&type=template&id=60ededc0&"
import script from "./CalendarDefault.vue?vue&type=script&lang=js&"
export * from "./CalendarDefault.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDefault.vue?vue&type=style&index=0&id=60ededc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports